<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 27/9/2020
  -->

<template>
	<div v-bind="attrsStylesClass" class="qwoach-form tags-view-root relative input-border default-padding qw-row display-inline"
		 @click.stop
	>
<!--		draggable component became buggy when deleting or adding elements renders extra elements-->
<!--		<component :is="draggableComponentName"-->
<!--				   v-model="filteredData"-->
<!--				   ghost-class="ghost"-->
<!--				   class="display-inline"-->
<!--				   @change="notifyValueChanged()"-->
<!--					itemKey="usageCounter">-->
<!--			<template #item="{element: tag}">-->
							<span v-for="(tag, index) in filteredData" :key="index"
								  class="tag-margin">

				<component :is="tag.description ? 'ToolTipView' : 'SlottedSpan'" :text="textTrimmed(tag.description)" position="bottom">
					<template #icon>
						<qw-tag
							:tag="tag"
							:closable="!viewOnly"
							:isTagsClickable="isTagsClickable"
							:tagTitleMaxLength="tagTitleMaxLength"
							size="small"
							@close="handleClose(tag)"
							class="cursor-pointer"
							@click.stop="onTagClicked(tag)"
						/>
					</template>

				</component>
			</span>
<!--			</template>-->

<!--&lt;!&ndash;			</template>&ndash;&gt;-->

<!--		</component>-->
		<qw-link-button v-if="numberOfHiddenTags > 0" class="display-inline" @click.stop="toggleHide">
			<small>
				<span v-if="hideFilteredTags">...more</span>
				<span v-else>...show&nbsp;less</span>
			</small>
			<!--            <el-tag size="small">...and {{numberOfHiddenTags}} more</el-tag>-->
		</qw-link-button>

		<span v-if="inputVisible">

		<qw-autocomplete
			:fetch-suggestions="querySearchAsync"
			class="input-new-tag input-group-force"
			v-model="inputValue"
			ref="saveTagInput"
			size="small"
			:placeholder="'Type to create a ' + itemName.toLowerCase()"
			@blur="autocompleteBlur"
			@keyup.enter="handleInputConfirm()"
			@select="handleSelect"
		>
			<template #append>
				<qw-button
					class="clickable"
					@click.stop="handleInputConfirm()">{{ inputValue ? 'Create' : 'Close' }}
				</qw-button>
			</template>

			<template #default="{ item }">
				<div class="w-100 row mx-0 my-1 align-items-center font-size-2--">

					<qw-tag :tag="item" :closable="false" size="small" class="col px-2 mr-2 text-ellipsis font-size-2--"/>
					<CloseConfirm @confirmed="onDeleteTagClicked(item)"/>
				</div>
			</template>
		</qw-autocomplete>
					</span>

		<span v-else-if="canAddTag">
			<qw-link-button class="button-new-tag" :class="[addTagClass]" size="small"
							@click.stop="showInput">+ Add {{itemName}}
			</qw-link-button>
		</span>

	</div>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView"
import TagItem from "@shared/Tags/TagItem";
import CloseConfirm from "@/core/components/Controls/Buttons/DeleteButtons/CloseConfirm.vue";
import {ellipsisString} from "@/utils/helpers";
import {createDialogLazy} from "@/utils/helpers-external.js";
let TagDetailsDialog = () => import("@/core/components/Tags/TagDetailsDialog.vue");
import QwTag from "@/core/components/Controls/QwTag.vue";
import {classToClass} from "@qwoach/class-transformer-wrapper";
import draggable from 'vuedraggable'

import {deleteConfirmDialog} from "@/core/components/Dialogs/dialog";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import {defaultColorPickerPalette} from "@/core/js/PaletteEnum";
import NoneDraggable from "@/core/components/Tags/NoneDraggable.vue";
import SlottedSpan from "@/core/components/Tags/SlottedSpan.vue";

let tagDetailsDialog = createDialogLazy(TagDetailsDialog)

export default {
	name: "TagsView",
	components: {SlottedSpan, NoneDraggable, ToolTipView, QwTag, CloseConfirm, draggable},
	extends: BaseVModelView,
	props: {
		tagSuggestionsProvider: null,
		maxTags: {Number, default: 1000},
        itemName: {String, default: "Tag"},
		isTagsClickable: {Boolean, default: true},
		viewOnly: Boolean,
		shouldOpenDetailsOnTagCreation: Boolean,
		skipDeleteConfirmation: Boolean,
        rotateColors: Boolean,
        addTagClass: String,
		tagDescriptionMaxLength: {Number, default: 150},
		tagTitleMaxLength: Number,
		palette: {Array, default: () => defaultColorPickerPalette},
		assignRandomColor: Boolean,
	},


	inheritAttrs: false,
	data() {
		return {
			hideFilteredTags: true,
			inputVisible: false,
			inputValue: '',
			selectWasClicked: false,
			suggestionsCallback: null,
			lastQueryString: null,
			lastUsedColorIndex: 0		}
	},

	created(){
		let body = document.querySelector("body")
		console.log("TagsView: body.click = ", body.click)
		draggable.compatConfig = { MODE: 3 };
		body.click = null
	},
	mounted() {
	},
	methods: {

		formatDataIn(data) {
			return data.map(d => {
				if(typeof d === "string"){
					d = new TagItem(d)
				}
				return d
			})
		},

		autocompleteBlur() {
			console.log("TagsView.autocompleteBlur")
			// need to listen for activated change to handle it properly
			// if(!this.$refs.saveTagInput.activated){
			//     this.handleInputConfirm()
			// }
		},

		refreshSuggestionTags() {
			if (this.suggestionsCallback) {
				this.getSuggestions(this.lastQueryString)
					.then(results => this.suggestionsCallback(results))
					.catch(_ => this.suggestionsCallback([]))
			}
		},
		querySearchAsync(queryString, callback) {

			this.suggestionsCallback = callback
			this.lastQueryString = queryString

			this.getSuggestions(queryString)
				.then(results => callback(results))
				.catch(error => {
					console.error(error)
					callback([])
				})
		},

		getSuggestions(queryString) {
			let resultsPromise = Promise.resolve([])
			if (this.tagSuggestionsProvider) {
				console.log("this.tagSuggestionsProvider = ", this.tagSuggestionsProvider)
				resultsPromise = this.tagSuggestionsProvider(queryString)
			}
			return resultsPromise
		},


		async handleClose(tag) {
			let res = this.skipDeleteConfirmation || await deleteConfirmDialog({itemName: this.itemNameProp})
			if (res) {
				this.deleteTag(tag)
			}
		},

		deleteTag(tag) {
			this.valueData.splice(this.valueData.indexOf(tag), 1);
			this.notifyValueChanged()
		},

		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.setFocusOnInput()
			});
		},
		setFocusOnInput() {
			this.$refs.saveTagInput.focus();
		},

		handleInputConfirm(suggestionsTag) {
			console.log("handleInputConfirm: ", this.inputValue)
			let inputValue = this.inputValue;
			if (inputValue) {
				// this.valueData.push(new TagItem(inputValue));
				if (typeof inputValue === "string") {
					inputValue = new TagItem(inputValue)
					if(this.rotateColors){
						let len = this.palette.length
						this.lastUsedColorIndex = (this.lastUsedColorIndex + 1) % len
						inputValue.color = this.palette[this.lastUsedColorIndex]
					}
					suggestionsTag = inputValue
				}
                if(this.assignRandomColor){
                    // let len = this.palette.length
                    // inputValue.color = this.palette
                }
				this.valueData.push(inputValue);
				this.notifyValueChanged()
				if (this.shouldOpenDetailsOnTagCreation) {
					this.onTagClicked(inputValue, suggestionsTag)
				}
			}
			this.closeSuggestions()
		},
		closeSuggestions() {
			this.inputVisible = false;
			this.inputValue = '';
		},

		async onDeleteTagClicked(tag) {
			await this.handleAsync(this.emitPromise("removeSuggestion", tag))
		},

		async updateSuggestionTag(tag) {
			await this.handleAsync(this.emitPromise("updateSuggestion", tag))
		},

		handleSelect(item) {
			console.log("handleSelect: ", item)
			this.selectWasClicked = true
			this.inputValue = classToClass(item)
			this.inputValue.regenerateId()
			console.log(item);
			this.handleInputConfirm(item)
		},

		toggleHide() {
			this.hideFilteredTags = !this.hideFilteredTags
		},

		async onTagClicked(tagItem, suggestionsTag) {
			console.log("onTagClicked: ", tagItem, suggestionsTag)
			this.closeSuggestions()
			if(!this.isTagsClickable){
				return
			}
			let tagItemCopy = classToClass(tagItem)
			let itemRes = await tagDetailsDialog({
                itemNameProp: this.itemName,
				palette: this.palette,
				tagItem: tagItemCopy,
				onDelete: async (tag) => this.deleteTag(tag)
			});
			if (itemRes) {
				this.updateTag(itemRes)
				if(suggestionsTag){
					suggestionsTag.color = itemRes.color
					suggestionsTag.title = itemRes.title
					await this.updateSuggestionTag(suggestionsTag)
				}
			}
		},

		updateTag(tag) {
			let index = this.valueData.findIndex(tg => tg.id === tag.id)
			if (index >= 0) {
				this.valueData.splice(index, 1, tag);
				this.notifyValueChanged()
			}
		},

		textTrimmed(text) {
			return ellipsisString(text || "", this.tagDescriptionMaxLength, true)
		}
	},

	computed: {
		filteredData() {
			let arr = []
			if (this.hideFilteredTags && this.maxTags > 0 && this.valueData.length > this.maxTags) {
				for (let i = 0; i < this.maxTags; ++i) {
					arr.push(this.valueData[i])
				}
			} else {
				arr = this.valueData
			}
			// for(let tagItem of arr){
			// 	if(!tagItem.id){
			// 		tagItem.id = this.dataManager.generateId()
			// 	}
			// }
			console.log("filteredData: arr = ", arr)
			return arr
		},

		numberOfHiddenTags() {
			return this.valueData.length - this.maxTags
		},

		draggableComponentName() {
			return 'draggable' //this.viewOnly ? 'NoneDraggable' : 'draggable'
		},

        canAddTag(){
            return this.valueData.length < this.maxTags && !this.viewOnly
        }
	},
}
</script>

<style lang="scss">

.el-autocomplete-suggestion li {
	padding: 0 10px;
}

.qwoach-form{
	.tags-view-root{
		.input-new-tag{
			.el-input-group__append{
				//display: inline-flex;
				//box-shadow: 0 1px 0 0 var(--el-input-border-color) inset,0 -1px 0 0 var(--el-input-border-color) inset,-1px 0 0 0 var(--el-input-border-color) inset;
				//border: none !important;
				box-shadow: none !important;
			}
		}
	}
}

.tags-view-root {

	.el-input__wrapper{
		padding: 0;
	}

	.el-tooltip__trigger{
		display: inline-block;
		width: auto;
	}

	.el-tag {
		margin-right: 0.625rem; //10px
		margin-bottom: 0.3125rem; //5px
		margin-top: 0.3125rem; //5px
	}

	.button-new-tag {
		height: 1.25rem; //20px
		font-size: px-to-rem(12); //0.625rem; //10px
		line-height: 1.25rem;//20px
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		min-width: 12.5rem; //200px;
		//height: px-to-rem(40);
		//line-height: px-to-rem(40);
		//margin-bottom: 10px;
		vertical-align: middle;
		//height: 28px;
		//line-height: px-to-rem(40);
		//line-height: 28px;
		.el-input__wrapper{
			background-color: white;
			padding-right: 0;
			padding-top: 0;
			padding-bottom: 0;

		}
		.el-input__inner{
			height: 1.75rem; //28px;
			line-height: 1.75rem; //28px;
		}
		.el-input-group__append{
			display: inline-flex !important;
			border: none !important;
		}

	}

	.ghost {
		opacity: 0.5;
	}
}
</style>
